export const CRAWL_STATE = {
    POSTPROCESSING: 'POSTPROCESSING',
    COOKIE_SCAN: 'COOKIE_SCAN',
};
